import { render, staticRenderFns } from "./comp_Bulkshop-Input.vue?vue&type=template&id=c3c7315c&scoped=true"
import script from "./comp_Bulkshop-Input.vue?vue&type=script&lang=js"
export * from "./comp_Bulkshop-Input.vue?vue&type=script&lang=js"
import style0 from "./comp_Bulkshop-Input.vue?vue&type=style&index=0&id=c3c7315c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3c7315c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
